<h3>Login</h3>
<div *ngIf="!authService.authenticated">
    <button type="button" class="btn btn-primary" (click)="login()">Login with my AAD account</button>
</div>

<div *ngIf="authService.authenticated">
    <button type="button" class="btn btn-primary" (click)="logout()">Logout</button>
</div>

<!--<div *ngIf="!authService.authenticated">
    <button type="button" class="btn btn-primary" (click)="logout()">Logout and Clear AAD Cache</button>
</div>-->
